import { genStyleHooks } from '../../theme/internal';
import type { AliasToken, GenerateStyle } from '../../theme/internal';
import { blue, gray } from '../../theme/themes/colorPalette';

// biome-ignore lint/suspicious/noEmptyInterface: ComponentToken need to be empty by default
export interface ComponentToken {}

export interface TabButtonToken extends AliasToken {
  componentCls: string;
}

const genTabButtonStyle: GenerateStyle<TabButtonToken> = (token) => {
  const { componentCls } = token;
  return {
    [componentCls]: {
      display: 'inline-flex',
      alignItems: 'center',
      verticalAlign: 'middle',
      gap: 8,

      '&-title': {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '18px',
        color: gray[900],
      },

      '&-tabs': {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'stretch',
        height: 40,
        gap: 4,
        padding: 4,
        borderRadius: 4,
        border: `1px solid ${gray[100]}`,
        backgroundColor: gray[0],
        boxSizing: 'border-box',
        overflow: 'hidden',
        outline: 'none',
      },

      '&-indicator': {
        position: 'absolute',
        insetBlockStart: 4,
        height: 'calc(100% - 8px)',
        borderRadius: 4,
        border: `1px solid ${gray[900]}`,
        backgroundColor: blue[200],
        boxSizing: 'border-box',
        transition:
          'inset-inline-start 0.25s cubic-bezier(0.4, 0, 0.2, 1), width 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        zIndex: 1,
        pointerEvents: 'none',
      },

      '&-option': {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        paddingBlock: 0,
        paddingInline: 16,
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '20px',
        whiteSpace: 'nowrap',
        color: gray[900],
        cursor: 'pointer',
        userSelect: 'none',
        boxSizing: 'border-box',
        zIndex: 2,
        transition: 'color 0.25s',

        '&-disabled': {
          color: gray[500],
          cursor: 'not-allowed',
        },
      },

      '&-disabled': {
        [`${componentCls}-tabs`]: {
          backgroundColor: gray[50],
          cursor: 'not-allowed',
        },
        [`${componentCls}-indicator`]: {
          backgroundColor: gray[100],
          borderColor: gray[200],
        },
        [`${componentCls}-option`]: {
          color: gray[500],
          cursor: 'not-allowed',
        },
      },
    },
  };
};

export const useTabButtonStyle = genStyleHooks(
  'TabButton',
  (token) => [genTabButtonStyle(token)],
  undefined,
  { resetFont: false },
);
